import { type ReactElement } from "react";
import { BrowserRouter } from "react-router-dom";
import type { PublicClientApplication } from "@azure/msal-browser";
import type { AppConfig } from "@shell/auth/authConfig";
import { ExperienceShell } from "@shell/ExperienceShell";
import { ServiceWorkerUpdateToast } from "@shell/pwa";

export interface AppProps {
    readonly msalInstance: PublicClientApplication;
    readonly config: AppConfig;
}

// React Router wants a path basename without a trailing slash; Vite's
// BASE_URL always has one. Normalising here keeps the router in lockstep
// with the Vite `base` setting and the Traefik PathPrefix.
const ROUTER_BASENAME = import.meta.env.BASE_URL.replace(/\/$/, "");

export function App({ msalInstance, config }: AppProps): ReactElement {
    return (
        <BrowserRouter basename={ROUTER_BASENAME}>
            <ExperienceShell msalInstance={msalInstance} config={config} />
            {/* Portals to body; sits beside the shell so an auth-gate swap cannot unmount it. */}
            <ServiceWorkerUpdateToast />
        </BrowserRouter>
    );
}
